import { SVGProps } from 'react';

const Podcast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 17a1 1 0 0 0-2 0l.5 4.5a.5.5 0 0 0 1 0zM12 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.85 18.58a9 9 0 1 0-9.7 0M8 14a5 5 0 1 1 8 0m-3 3a1 1 0 0 0-2 0l.5 4.5a.5.5 0 0 0 1 0zm-1-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
);
export default Podcast;
